// Account-level constants shared across features.

export const USER_ROLES = {
  ADMIN: 'admin',
  MEMBER: 'member',
}

export const USER_ROLE_ICONS = {
  [USER_ROLES.ADMIN]: 'shield-check',
  [USER_ROLES.MEMBER]: 'user',
}

export const PLAN_STATUS = {
  TRIAL: 'trial',
  ACTIVE: 'active',
}

export const TRIAL_EXPIRING_SOON_DAYS = 7

/** Badge surfaces for plan status (trial + subscribed). */
export const PLAN_TONE_CLASS = {
  DEFAULT: 'bg-accent-light text-brand-dark',
  EXPIRING_SOON: 'bg-cta-light text-cta-dark',
  ACTIVE: 'bg-positive-extra-light text-positive',
}

/** Backend error codes for account setup and update flows. */
export const ACCOUNT_ERROR_CODE = {
  ACCOUNT_ALREADY_SET_UP: 'account_already_set_up',
  ACCOUNT_NAME_TAKEN: 'account_name_taken',
}
